import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAssetDetailsContext } from "../../context/assetDetailsContext";
import { fromDate } from "../../reducers/assetDetailsReducer";

export const useInitialValues = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const {
		state: { currentGridName },
	} = useAssetDetailsContext();

	useEffect(() => {
		let shouldUpdate = false;

		if (!searchParams.has("resource")) {
			searchParams.set("resource", currentGridName || "documents");
			shouldUpdate = true;
		}

		if (!searchParams.has("assets")) {
			searchParams.set("assets", "true");
			shouldUpdate = true;
		}

		if (!searchParams.has("statistics")) {
			searchParams.set("statistics", "true");
			shouldUpdate = true;
		}

		if (!searchParams.has("workOrders")) {
			searchParams.set("workOrders", "true");
			shouldUpdate = true;
		}

		if (!searchParams.has("start")) {
			searchParams.set("start", encodeURIComponent(fromDate.toJSON()));
			shouldUpdate = true;
		}

		if (!searchParams.has("end")) {
			searchParams.set(
				"end",
				encodeURIComponent(
					moment().hour(23).minute(59).second(59).toDate().toJSON(),
				),
			);
			shouldUpdate = true;
		}

		if (!searchParams.has("status")) {
			searchParams.set("status", "O");
			shouldUpdate = true;
		}

		if (!searchParams.has("type")) {
			searchParams.set("type", "A");
			shouldUpdate = true;
		}

		if (!searchParams.has("craft")) {
			searchParams.set("craft", "A");
			shouldUpdate = true;
		}

		if (shouldUpdate) setSearchParams(searchParams, { replace: true });
	}, [searchParams]);
};
